import { z } from 'zod';

export enum TimeRangeKind {
  RELATIVE_TIME_RANGE = 0,
  ABSOLUTE_TIME_RANGE = 1,
  ALL_TO_DATE = 2,
}

export interface RelativeTimeRange {
  lastNumDays: number;
}

export interface AbsoluteTimeRange {
  fromTimestamp?: number;
  toTimestamp?: number;
}

export const TimeRangeSchema = z
  .object({
    kind: z.preprocess((value: any) => parseInt(value, 10), z.literal(TimeRangeKind.ALL_TO_DATE)),
  })
  .or(
    z.object({
      kind: z.preprocess((value: any) => parseInt(value, 10), z.literal(TimeRangeKind.RELATIVE_TIME_RANGE)),
      relative: z
        .object({
          lastNumDays: z.coerce.number(),
        })
        .optional(),
    })
  )
  .or(
    z.object({
      kind: z.preprocess((value: any) => parseInt(value, 10), z.literal(TimeRangeKind.ABSOLUTE_TIME_RANGE)),
      absolute: z
        .object({
          fromTimestamp: z.coerce.number().int().safe().optional(),
          toTimestamp: z.coerce.number().int().safe().optional(),
        })
        .optional(),
    })
  );

export type TimeRange = z.infer<typeof TimeRangeSchema>;

export interface ReportingPeriod {
  current: AbsoluteTimeRange;
  previous: AbsoluteTimeRange;
  timeRange: number;
}
